<template>
    <div>
        <label class="d-block mb-1 small">Container</label>
        <select @change="savePageContainerId" class="form-select form-select-sm w-auto">
            <option value="" selected disabled>Select&hellip;</option>
            <option v-for="o in pageSectionTemplates" :key="o.id" :value="o.id" :selected="o.id === section.pageContainerId">
                {{ o.title }}
            </option>
        </select>
    </div>
</template>

<script>
export default {
    name: "PageContentSectionsContainerMenu",
    props: {
        sectionId: Number
    },
    computed: {
        section() {
            return this.$store.state.pageSections.items.find(o => o.id === this.sectionId)
        }
    },
    asyncComputed: {
        // todo This should be provided by a VueX module
        async pageSectionTemplates() {
            return (await this.$store.dispatch('request/get', {
                url: 'api/component/templates_templates',
                params: {type: 'container', sort: 'title'}
            }, {root: true})).data.items
        }
    },
    methods: {
        async savePageContainerId(e) {
            const pageContainerId = parseInt(e.target.value)

            await this.$store.dispatch('request/post', {
                url: 'api/page-section/' + this.sectionId,
                postData: {pageContainerId}
            }, {root: true})

            await this.$store.dispatch('pageSections/init', true)
        }
    }
}
</script>

<style scoped>

</style>